const { CarouselElement } = window.BAO.Carousel
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

export class ReviewCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide']
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    const isSide = this.dataset.layout === 'side'

    return {
      slides: {
        perView: 'auto',
        spacing: 10,
        origin: 'auto',
      },
      loop: false,
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 'auto',
            spacing: isSide ? 15 : 20,
            origin: 'auto',
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: 'auto',
            spacing: isSide ? 50 : 30,
            origin: 'auto',
          },
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    return [
      setInitialised(),
      useArrows({
        next: this.els.next.element,
        previous: this.els.previous.element,
      }),
    ]
  }
}

customElements.define('review-carousel', ReviewCarousel)
